<template>
    <div class="cashup-new-template-container position-relative min-h-300">

        <template v-if="!isRetreiving">
            <div class="cashup_header d-flex justify-content-between align-items-center w-100 m-bottom-1rem">

                <div>
                    <div class="header-container">
                        <span>
                                {{ `CASH UP AND BANKING AS OF ${reportDateWithFormat}` }}
                        </span>
                    </div>
                    <el-input :ref="`manager`" v-model="manager" @keyup.native.enter="keyupProcess('safe_count00', 1)" @change="saveCashupOnly" :class="{'is-error' : !$box.checkCashupValueExists(manager)}" class="peiso-input-default max-350 b-right-bottom" placeholder="Manager's name"></el-input>
                </div>
                <div class="d-flex gap-16">
                    <div class="save-container d-flex justify-content-end ml-3">
                        <el-button type="peiso-primary-pink-border-only" v-if="!isLoadingSend" class="px-2rem" @click="saveCashupRecord(true)">Send And Save record</el-button>
                        <el-button type="peiso-primary-pink-border-only" v-if="isLoadingSend" class="px-2rem cursor-disable"><i class="el-icon-loading"></i> &nbsp;Sending And Saving record...</el-button>
                    </div>
                </div>
            </div>

            <div class="d-flex gap-32" style="margin-bottom: 5rem;">
                <div class="left w-100">
                    <div class="">
                        <el-collapse class="peiso-collapse cashup__wrapper" accordion>
                            <el-collapse-item :title="item.name" :name="idx" v-for="(item, idx) in tills" :key="`tills${idx}`">
                                <div class="cashup__table">
                                    <div class="cashup__row header d-flex align-items-center">
                                        <div class="label h-50 w-100 text-center max-150 b-right-bottom">Denomination</div>

                                        <div class="label h-50 w-100 text-center max-125 b-right-bottom">Count</div>
                                        <div class="label h-50 w-100 text-center b-right-bottom light-bg">Total</div>
                                        <!-- <div class="label h-50 w-100 text-center b-right-bottom light-bg">Rolls</div> -->
                                        <div class="label h-50 w-100 text-center b-bottom light-bg">Balance</div>
                                    </div>

                                    <div class="cashup__row d-flex align-items-center" v-for="(safe, i) in item.safe_counts" :key="`tills${i}`">
                                        <div class="label h-40 h-100 w-100 max-150 b-right-bottom">{{ safe.count_label }}</div>
                                        <el-input-number v-model="safe.count" :ref="`safe_count${idx}${i}`" class="peiso-input-default h-40 w-100 center-align max-125 b-right-bottom" @input="getTillsTotalCash" @change="getBalanced" :class="{'is-error' : !$box.checkCashupValueExists(safe.count)}"  @keyup.native.enter="keyupProcess(i == 10 ? `promo${idx}` : `safe_count${idx}${i+1}`, 1)" controls-position="right" step-strictly></el-input-number>
                                        <!-- <input-number v-model="safe.count" :class="{'is-error' : !$box.checkCashupValueExists(item.promo)}" class="peiso-numerical h-40 center-align max-125 b-right-bottom" :ref="`safe_count${idx}${i}`" @change="saveCashupOnly()" @nextInput="keyupProcess(i == 10 ? `promo${idx}` : `safe_count${idx}${i+1}`, 1)" @input="getTillsTotalCash" :value="0" :empty-value="null" :precision="0" currency=""></input-number> -->

                                        <el-input :value="$box.formatMoney5($box.getTotal(safe.value, safe.count))" class="peiso-input-default h-40 right-align b-right-bottom light-bg"></el-input>
                                        <!-- <el-input :value="$box.getRollCount(safe.rolls, safe.count)" class="peiso-input-default h-40 center-align b-right-bottom light-bg"></el-input> -->
                                        <el-input v-model="safe.balance" type="number" class="peiso-input-default h-40 center-align b-bottom light-bg"></el-input>
                                    </div>

                                    <div class="cashup__row header d-flex align-items-center">
                                        <div class="label h-50 w-100 text-center font-weight-bold max-150 b-right-bottom">Total</div>
                                        <div class="label h-50 w-100 text-center max-125 b-right-bottom"></div>
                                        <div class="label h-50 w-100 text-center justify-content-end font-weight-bold b-right-bottom light-bg">{{ $box.formatMoney5(item.total_cash_amount) }}</div>
                                        <!-- <div class="label h-50 w-100 text-center b-right-bottom light-bg"></div> -->
                                        <div class="label h-50 w-100 text-center b-right-bottom light-bg"></div>
                                    </div>

                                    <div class="cashup__row header d-flex align-items-center">
                                        <div class="label h-50 w-100 text-center font-weight-bold max-150 b-right-bottom">Till Float</div>
                                        <div class="label h-50 w-100 text-center max-125 b-right-bottom"></div>
                                        <div class="label h-50 w-100 text-center justify-content-end font-weight-bold b-right-bottom light-bg">{{ $box.formatMoney5(item.default_float) }}</div>
                                        <!-- <div class="label h-50 w-100 text-center b-right-bottom light-bg"></div> -->
                                        <div class="label h-50 w-100 text-center b-right-bottom light-bg"></div>
                                    </div>

                                    <div class="cashup__row header d-flex align-items-center">
                                        <div class="label h-50 w-100 text-center font-weight-bold max-150 b-right-bottom">TOTAL CASH</div>
                                        <div class="label h-50 w-100 text-center max-125 b-right-bottom"></div>
                                        <div class="label h-50 w-100 text-center justify-content-end font-weight-bold b-right-bottom light-bg">{{ $box.formatMoney5(item.total_cash) }}</div>
                                        <!-- <div class="label h-50 w-100 text-center b-right-bottom light-bg"></div> -->
                                        <div class="label h-50 w-100 text-center b-right-bottom light-bg"></div>
                                    </div>

                                </div>
                                <div class="cashup__table">
                                    <div class="cashup__header d-flex">
                                    </div>

                                    <div v-if="promoVisibility" class="cashup__row d-flex align-items-center">
                                        <div class="label justify-content-start font-weight-bold text-left h-40 h-100 w-100 max-270 b-right-bottom">{{ promoLabel }}</div>
                                        <!-- <el-input v-model="item.promo" :ref="`promo${idx}`" @keyup.native.enter="keyupProcess(`receipt${idx}`, 1)" v-mask="currencyMask" @input="getTillsTotalCash" @change="saveCashupOnly()" class="peiso-input-default h-40 right-align max-150 b-right-bottom"></el-input> -->
                                        <input-number v-model="item.promo" :class="{'is-error' : !$box.checkCashupValueExists(item.promo)}" class="peiso-numerical h-40 right-align max-150 b-right-bottom" :ref="`promo${idx}`" @change="saveCashupOnly()" @nextInput="keyupProcess(`receipt${idx}`, 1)" @input="getTillsTotalCash" :value="0" :empty-value="null" :precision="2"></input-number>
                                    </div>
                                    <div v-if="receiptVisibility" class="cashup__row d-flex align-items-center">
                                        <div class="label justify-content-start font-weight-bold h-40 h-100 w-100 max-270 b-right-bottom">{{ receiptLabel }}</div>
                                        <!-- <el-input v-model="item.receipt" :ref="`receipt${idx}`" @keyup.native.enter="keyupProcess(`eft_pos${idx}`, 1)" v-mask="currencyMask" @input="getTillsTotalCash" :class="{'is-error' : !$box.checkCashupValueExists(item.receipt)}" @change="saveCashupOnly()" class="peiso-input-default h-40 right-align max-150 b-right-bottom"></el-input> -->
                                        <input-number v-model="item.receipt" :class="{'is-error' : !$box.checkCashupValueExists(item.receipt)}" class="peiso-numerical h-40 right-align max-150 b-right-bottom" :ref="`receipt${idx}`" @change="saveCashupOnly()" @nextInput="keyupProcess(`eft_pos${idx}`, 1)" @input="getTillsTotalCash" :value="0" :empty-value="null" :precision="2"></input-number>

                                    </div>
                                    <div class="cashup__row d-flex align-items-center">
                                        <div class="label justify-content-start font-weight-bold h-40 h-100 w-100 max-270 b-right-bottom">EFT POS</div>
                                        <!-- <el-input v-model="item.eft_pos" :ref="`eft_pos${idx}`" @keyup.native.enter="keyupProcess(`takings${idx}`, 1)" v-mask="currencyMask" @input="getTillsTotalCash" :class="{'is-error' : !$box.checkCashupValueExists(item.eft_pos)}" @change="saveCashupOnly()" class="peiso-input-default h-40 right-align max-150 b-right-bottom"></el-input> -->
                                        <input-number v-model="item.eft_pos" :class="{'is-error' : !$box.checkCashupValueExists(item.eft_pos)}" class="peiso-numerical h-40 right-align max-150 b-right-bottom" :ref="`eft_pos${idx}`" @change="saveCashupOnly()" @nextInput="keyupProcess(`takings${idx}`, 1)" @input="getTillsTotalCash" :value="0" :empty-value="null" :precision="2"></input-number>
                                    </div>
                                    <div class="cashup__row d-flex align-items-center">
                                        <div class="label justify-content-start font-weight-bold h-40 h-100 w-100 max-270 b-right-bottom">CASH</div>
                                        <el-input :value="$box.formatMoney5(item.cash)" @input="getTillsTotalCash" class="peiso-input-default h-40 right-align max-150 b-right-bottom"></el-input>
                                    </div>
                                    <div class="cashup__row d-flex align-items-center">
                                        <div class="label justify-content-start font-weight-bold h-40 h-100 w-100 max-270 b-right-bottom">TOTAL</div>
                                        <el-input :value="$box.formatMoney5(item.total)" @input="getTillsTotalCash" class="peiso-input-default h-40 right-align max-150 b-right-bottom"></el-input>
                                    </div>
                                    <div class="cashup__row d-flex align-items-center">
                                        <div class="label justify-content-start font-weight-bold h-40 h-100 w-100 max-270 b-right-bottom">TAKINGS</div>
                                        <!-- <el-input v-model="item.takings" :ref="`takings${idx}`" v-mask="currencyMask" @input="getTillsTotalCash" :class="{'is-error' : !$box.checkCashupValueExists(item.takings)}" @change="saveCashupOnly()" class="peiso-input-default h-40 right-align max-150 b-right-bottom"></el-input> -->
                                        <input-number v-model="item.takings" :class="{'is-error' : !$box.checkCashupValueExists(item.takings)}" class="peiso-numerical h-40 right-align max-150 b-right-bottom" :ref="`takings${idx}`" @change="saveCashupOnly()" @input="getTillsTotalCash" :value="0" :empty-value="null" :precision="2"></input-number>
                                    </div>
                                    <div class="cashup__row d-flex align-items-center">
                                        <div class="label justify-content-start font-weight-bold h-40 h-100 w-100 max-270 b-right-bottom">TOTAL VARIANCE</div>
                                        <el-input :value="`${item.total_variance > 0 ? '+' : ''}${$box.formatMoney5(item.total_variance)}`" @input="getTillsTotalCash" :class="`${item.total_variance < 0 ? 'peiso-input-default-red' : ''}`" class="peiso-input-default h-40 right-align max-150 b-right-bottom"></el-input>
                                    </div>
                                </div>
                            </el-collapse-item>

                        </el-collapse>
                    </div>

                    <div class="">
                        <el-collapse v-model="isActiveCashTaking" class="peiso-collapse cashup__wrapper daily_total_cash_takings">
                            <el-collapse-item :title="dailyCashTaking.name" name="1">
                                <div class="cashup__table">
                                    <div class="cashup__row header d-flex align-items-center">
                                        <div class="label h-50 w-100 text-center b-right-bottom">Denomination</div>

                                        <div class="label h-50 w-100 text-center b-right-bottom">Count</div>
                                        <div class="label h-50 w-100 text-center b-right-bottom light-bg">Total</div>
                                        <!-- <div class="label h-50 w-100 text-center b-right-bottom light-bg">Rolls</div> -->
                                    </div>

                                    <div class="cashup__row header d-flex align-items-center" v-for="(safe, i) in dailyCashTaking.safe_counts" :key="`tills${i}`">
                                        <div class="label h-40 px-0 h-100 w-100 b-right-bottom">{{ safe.count_label }}</div>

                                        <div class="label h-40 px-0 w-100 text-center b-right-bottom">
                                            <!-- <el-input v-model="safe.count" type="number" pattern="[0-9]" :ref="`daily_taking_count${i}`" @input="getCashTakingTotalCash" :class="{'is-error' : !$box.checkCashupValueExists(safe.count)}" @change="saveCashupOnly()" class="peiso-input-default h-40 w-100 center-align b-right-bottom" @keyup.native.enter="keyupProcess(i == 10 ? `daily_taking_taking1` : `daily_taking_count${i+1}`, i == 10 ? 0 : 1)"></el-input> -->
                                            <el-input-number v-model="safe.count" :ref="`daily_taking_count${i}`" class="peiso-input-default h-40 w-100 center-align b-right-bottom"  @input="getCashTakingTotalCash" @change="saveCashupOnly()" :class="{'is-error' : !$box.checkCashupValueExists(safe.count)}"  @keyup.native.enter="keyupProcess(i == 10 ? `daily_taking_taking1` : `daily_taking_count${i+1}`, i == 10 ? 0 : 1)" controls-position="right" step-strictly></el-input-number>
                                        </div>
                                        <div class="label h-40 px-0 w-100 text-center b-right-bottom light-bg">
                                            <el-input :value="$box.formatMoney5($box.getTotal(safe.value, safe.count))" class="peiso-input-default h-40 w-100 right-align b-right-bottom light-bg"></el-input>
                                        </div>
                                    </div>

                                    <div class="cashup__row header d-flex align-items-center">
                                        <div class="label h-50 w-100 text-center font-weight-bold b-right-bottom">TOTAL CASH</div>
                                        <div class="label h-50 w-100 text-center b-right-bottom"></div>
                                        <div class="label h-50 w-100 justify-content-end text-center font-weight-bold b-right-bottom light-bg">{{ $box.formatMoney5(dailyCashTaking.total_cash) }}</div>
                                        <!-- <div class="label h-50 w-100 text-center b-right-bottom light-bg"></div> -->
                                    </div>

                                    <div class="cashup__row header d-flex align-items-center">
                                        <div class="label h-50 w-100 text-center font-weight-bold b-right-bottom">CASH VARIANCE</div>
                                        <div class="label h-50 w-100 text-center b-right-bottom"></div>
                                        <div class="label h-50 w-100 justify-content-end text-center font-weight-bold b-right-bottom light-bg" :class="`${dailyCashTaking.variance < 0 ? 'text-red' : ''}`"><span v-if="dailyCashTaking.variance > 0">+</span>{{ $box.formatMoney5(dailyCashTaking.variance) }}</div>
                                        <!-- <div class="label h-50 w-100 text-center b-right-bottom light-bg"></div> -->
                                    </div>
                                </div>

                                <div class="cashup__table">

                                    <div class="cashup__header d-flex">

                                    </div>

                                    <div v-if="promoVisibility" class="cashup__row d-flex align-items-center">
                                        <div class="label justify-content-start font-weight-bold h-40 h-100 w-100 max-270 b-right-bottom">{{ promoLabel }}</div>
                                        <el-input :value="$box.formatMoney5(dailyCashTaking.promo)" :ref="`daily_tasking_promo`" class="peiso-input-default h-40 right-align max-150 b-right-bottom"></el-input>
                                    </div>
                                    <div v-if="receiptVisibility" class="cashup__row d-flex align-items-center">
                                        <div class="label justify-content-start font-weight-bold text-left h-40 h-100 w-100 max-270 b-right-bottom">{{ receiptLabel }}</div>
                                        <el-input :value="$box.formatMoney5(dailyCashTaking.receipt)" class="peiso-input-default h-40 right-align max-150 b-right-bottom"></el-input>
                                    </div>
                                    <div class="cashup__row d-flex align-items-center">
                                        <div class="label justify-content-start font-weight-bold h-40 h-100 w-100 max-270 b-right-bottom">EFT POS</div>
                                        <el-input :value="$box.formatMoney5(dailyCashTaking.eft_pos)" class="peiso-input-default h-40 right-align max-150 b-right-bottom"></el-input>
                                    </div>
                                    <div class="cashup__row d-flex align-items-center">
                                        <div class="label justify-content-start font-weight-bold h-40 h-100 w-100 max-270 b-right-bottom">CASH</div>
                                        <!-- <el-input :value="$box.formatMoney5(dailyCashTaking.total_cash)" type="number" @input="getCashTakingTotalCash" class="peiso-input-default h-40 right-align max-150 b-right-bottom"></el-input> -->
                                        <div class="label justify-content-end font-weight-bold h-40 h-100 w-100 max-150 b-right-bottom">{{ $box.formatMoney5(dailyCashTaking.total_cash) }}</div>
                                    </div>
                                    <div class="cashup__row d-flex align-items-center">
                                        <div class="label justify-content-start font-weight-bold h-40 h-100 w-100 max-270 b-right-bottom">TOTAL</div>
                                        <!-- <el-input :value="$box.formatMoney5(dailyCashTaking.total)" type="number" class="peiso-input-default h-40 right-align max-150 b-right-bottom"></el-input> -->
                                        <div class="label justify-content-end font-weight-bold h-40 h-100 w-100 max-150 b-right-bottom">{{ $box.formatMoney5(dailyCashTaking.total) }}</div>

                                    </div>
                                    <div class="cashup__row d-flex align-items-center">
                                        <div class="label justify-content-start font-weight-bold h-40 h-100 w-100 max-270 b-right-bottom">TAKINGS</div>
                                        <!-- <el-input v-model="dailyCashTaking.takings" :ref="`daily_taking_taking1`" @keyup.native.enter="keyupProcess('manager1')" @input="getCashTakingTotalCash" :class="{'is-error' : !$box.checkCashupValueExists(dailyCashTaking.takings)}" @change="saveCashupOnly()" class="peiso-input-default h-40 right-align max-150 b-right-bottom"></el-input> -->
                                        <input-number v-model="dailyCashTaking.takings" :class="{'is-error' : !$box.checkCashupValueExists(dailyCashTaking.takings)}" class="peiso-numerical h-40 right-align max-150 b-right-bottom" @change="saveCashupOnly()" @nextInput="keyupProcess(`manager1`)" @input="getTillsTotalCash" :value="0" :empty-value="0" :precision="2"></input-number>
                                    </div>
                                    <div class="cashup__row d-flex align-items-center">
                                        <div class="label justify-content-start font-weight-bold h-40 h-100 w-100 max-270 b-right-bottom">TOTAL VARIANCE</div>
                                        <div class="label justify-content-end font-weight-bold h-40 h-100 w-100 max-150 b-right-bottom" :class="`${dailyCashTaking.total_variance < 0 ? 'text-red' : ''}`"><span v-if="dailyCashTaking.total_variance > 0">+</span>{{ $box.formatMoney5(dailyCashTaking.total_variance) }}</div>
                                    </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>

                </div>
                <div class="right w-100">

                    <div v-if="safeCountVisibility" class="cashup__wrapper dark-bg m-bottom-1rem safe_counts">
                        <div class="cashup__table">
                            <div class="cashup__row d-flex align-items-center">
                                <div class="label d-flex justify-content-center align-items-center font-weight-bold h-40 h-100 w-100 b-right-bottom">SAFE COUNTS</div>
                                <div class="label d-flex justify-content-center align-items-center font-weight-bold h-40 h-100 w-100 b-right-bottom">OPEN</div>
                                <div class="label d-flex justify-content-center align-items-center font-weight-bold h-40 h-100 w-100 b-right-bottom">CLOSE </div>
                            </div>
                            <div class="cashup__row d-flex align-items-center">
                                <div class="w-100">
                                    <div class="label d-flex justify-content-start px-1rem align-items-center font-weight-bold h-40 h-100 w-100 b-right-bottom">
                                        Manager name
                                    </div>

                                </div>
                                <div class="d-flex align-items-center h-40 w-100 b-right-bottom">
                                    <el-input v-model="consolidatedSafeCounts.open_manager" :ref="`manager1`" @keyup.native.enter="keyupProcess('open_count0', 1)" :class="{'is-error' : !$box.checkCashupValueExists(consolidatedSafeCounts.open_manager)}" @change="saveCashupOnly()" class="peiso-input-default h-40 center-align b-right-bottom"></el-input>
                                </div>
                                <div class="d-flex align-items-center h-40 w-100 b-right-bottom">
                                    <el-input v-model="consolidatedSafeCounts.close_manager" :ref="`manager2`" @keyup.native.enter="keyupProcess(`close_count0`, 1)" :class="{'is-error' : !$box.checkCashupValueExists(consolidatedSafeCounts.close_manager)}" @change="saveCashupOnly()" class="peiso-input-default h-40 center-align b-right-bottom"></el-input>
                                </div>
                            </div>
                            <div class="cashup__row d-flex align-items-center">
                                <div class="w-100">
                                    <div class="label d-flex justify-content-center align-items-center font-weight-bold h-40 h-100 w-100 b-right-bottom"></div>

                                </div>
                                <div class="d-flex align-items-center h-40 w-100 b-right-bottom">
                                    <div class="label d-flex justify-content-center align-items-center font-weight-bold h-100 w-100 max-90 b-right-bottom">Counts</div>
                                    <div class="label d-flex justify-content-center align-items-center font-weight-bold h-100 w-100 b-right-bottom light-bg">Total</div>
                                </div>
                                <div class="d-flex align-items-center h-40 w-100 b-right-bottom">
                                    <div class="label d-flex justify-content-center align-items-center font-weight-bold h-100 w-100 max-90 b-right-bottom">Counts</div>
                                    <div class="label d-flex justify-content-center align-items-center font-weight-bold h-100 w-100 b-right-bottom light-bg">Total</div>
                                </div>
                            </div>

                            <div class="cashup__row d-flex align-items-center" v-for="(item, i) in consolidatedSafeCounts.safe_counts" :key="`open-${i}`">
                                <div class="w-100">
                                    <div class="label d-flex justify-content-start align-items-center px-2rem font-weight-bold h-40 h-100 w-100 b-right-bottom">{{ item.count_label }}</div>
                                </div>
                                <div class="d-flex align-items-center h-40 w-100 b-right-bottom">
                                    <el-input-number v-model="item.open_count" :ref="`open_count${i}`" @keyup.native.enter="keyupProcess(i == 10 ? `manager2` : `open_count${i+1}`, i == 10 ? 0 : 1)" @input="getSafeCountsTotal" :class="{'is-error' : !$box.checkCashupValueExists(item.open_count)}" @change="saveCashupOnly()" class="peiso-input-default h-40 center-align max-90 b-right-bottom" controls-position="right" step-strictly></el-input-number>
                                    <el-input :value="$box.formatMoney5(item.open_total)" class="peiso-input-default h-40 right-align b-right-bottom light-bg"></el-input>
                                </div>
                                <div class="d-flex align-items-center h-40 w-100 b-right-bottom">
                                    <el-input v-model="item.close_count" :ref="`close_count${i}`" @keyup.native.enter="keyupProcess(i == 10 ? isTabVarianceShow ? `daily_read1` : `feedback1` : `close_count${i+1}`, i == 10 ? 0 : 1)" @input="getSafeCountsTotal" :class="{'is-error' : !$box.checkCashupValueExists(item.close_count)}" @change="saveCashupOnly()" class="peiso-input-default h-40 center-align max-90 b-right-bottom"></el-input>
                                    <el-input :value="$box.formatMoney5(item.close_total)" class="peiso-input-default h-40 right-align b-right-bottom light-bg"></el-input>
                                </div>
                            </div>
                            <div class="cashup__row d-flex align-items-center">
                                <div class="w-100">
                                    <div class="label d-flex justify-content-start align-items-center px-1rem font-weight-bold h-40 h-100 w-100 b-right-bottom">Total Cash</div>

                                </div>
                                <div class="d-flex align-items-center h-40 w-100 b-right-bottom">
                                    <el-input :value="$box.formatMoney5(consolidatedSafeCounts.open_total_counts)" class="peiso-input-default h-40 right-align b-right-bottom light-bg"></el-input>
                                </div>
                                <div class="d-flex align-items-center h-40 w-100 b-right-bottom">
                                    <el-input :value="$box.formatMoney5(consolidatedSafeCounts.close_total_counts)" class="peiso-input-default h-40 right-align b-right-bottom light-bg"></el-input>
                                </div>
                            </div>
                            <div class="cashup__row d-flex align-items-center">
                                <div class="w-100">
                                    <div class="label d-flex justify-content-start align-items-center px-1rem font-weight-bold h-40 h-100 w-100 b-right-bottom">Safe Float</div>

                                </div>
                                <div class="d-flex align-items-center h-40 w-100 b-right-bottom">
                                    <el-input :value="$box.formatMoney5(consolidatedSafeCounts.open_safe_float)" class="peiso-input-default h-40 right-align b-right-bottom light-bg"></el-input>
                                </div>
                                <div class="d-flex align-items-center h-40 w-100 b-right-bottom">
                                    <el-input :value="$box.formatMoney5(consolidatedSafeCounts.close_safe_float)" class="peiso-input-default h-40 right-align b-right-bottom light-bg"></el-input>
                                </div>
                            </div>
                            <div class="cashup__row d-flex align-items-center">
                                <div class="w-100">
                                    <div class="label d-flex justify-content-start align-items-center px-1rem font-weight-bold h-40 h-100 w-100 b-right-bottom">Variance</div>

                                </div>
                                <div class="d-flex align-items-center h-40 w-100 b-right-bottom">
                                    <el-input :value="`${consolidatedSafeCounts.open_variance > 0 ? '+' : ''}${$box.formatMoney5(consolidatedSafeCounts.open_variance)}`" :class="`${consolidatedSafeCounts.open_variance < 0 ? 'peiso-input-default-red' : ''}`" class="peiso-input-default h-40 right-align b-right-bottom light-bg"></el-input>
                                </div>
                                <div class="d-flex align-items-center h-40 w-100 b-right-bottom">
                                    <el-input :value="`${consolidatedSafeCounts.close_variance > 0 ? '+' : ''}${$box.formatMoney5(consolidatedSafeCounts.close_variance)}`" :class="`${consolidatedSafeCounts.close_variance < 0 ? 'peiso-input-default-red' : ''}`"  class="peiso-input-default h-40 right-align b-right-bottom light-bg"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="isTabVarianceShow" class="cashup__wrapper dark-bg m-bottom-1rem">
                        <div class="cashup__table">
                            <div class="cashup__row d-flex align-items-center">
                                <div class="label d-flex justify-content-center align-items-center font-weight-bold h-40 w-100 b-right-bottom">TAB VARIANCE</div>
                            </div>

                            <div class="cashup__row d-flex align-items-center ">
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold h-40 w-100 b-right-bottom px-1rem">Daily Read</div>
                                <el-input v-model="otherDetails.daily_read" v-mask="currencyMask" :ref="`daily_read1`" @keyup.native.enter="keyupProcess(`variance1`, 0)" :class="{'is-error' : !$box.checkCashupValueExists(otherDetails.daily_read)}" @change="saveCashupOnly()" class="peiso-input-default h-40 center-align max-200 b-right-bottom"></el-input>
                            </div>
                            <div class="cashup__row d-flex align-items-center ">
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold h-40 w-100 b-right-bottom px-1rem">Variance</div>
                                <el-input v-model="otherDetails.tab_variance" v-mask="currencyMask" :ref="`variance1`" @keyup.native.enter="keyupProcess(`feedback1`, 0)" :class="{'is-error' : !$box.checkCashupValueExists(otherDetails.tab_variance), 'peiso-input-default': (otherDetails.tab_variance < 0)}" @change="saveCashupOnly()" class="peiso-input-default h-40 center-align max-200 b-right-bottom"></el-input>
                            </div>
                        </div>
                    </div>

                    <div class="cashup__wrapper dark-bg m-bottom-1rem">
                        <div class="cashup__table">
                            <div class="cashup__row d-flex align-items-center">
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold h-40 w-100 b-right-bottom px-1rem">Comments</div>
                            </div>
                            <div class="cashup__row d-flex align-items-center ">
                                <el-input v-model="otherDetails.feedback" :ref="`feedback1`" type="textarea" :class="{'is-error' : !$box.checkCashupValueExists(otherDetails.feedback)}" @change="saveCashupOnly()" class="peiso-input-default left-align b-right-bottom" placeholder="Input feedback here..."></el-input>
                            </div>
                        </div>
                    </div>

                    <div class="cashup__wrapper dark-bg m-bottom-1rem">
                        <div class="cashup__table">
                            <div class="cashup__row d-flex align-items-center">
                                <!-- <div class="label d-flex justify-content-start align-items-center font-weight-bold h-40 w-100 b-right-bottom px-1rem">Comments</div> -->
                            </div>
                            <div class="cashup__row d-flex align-items-center ">
                                <el-table
                                    :data="tills"
                                    border
                                    class="dark-bg custom-table"
                                    style="width: 100%">
                                        <el-table-column
                                            prop="name"
                                            label="Terminal Name">
                                        </el-table-column>
                                      
                                        <el-table-column
                                            prop="total_variance"
                                            label="Variance">
                                            <template slot-scope="scope">
                                                <span :class="`${scope.row.total_variance < 0 ? 'text-red' : scope.row.total_variance > 1 ? 'text-green' : ''}`">{{`${scope.row.total_variance > 0 ? '+' : ''}${$box.formatMoney5(scope.row.total_variance)}`}}</span>
                                               
                                            </template>
                                        </el-table-column>
                                </el-table>

                            </div>
                        </div>
                    </div>

                    <div v-if="receiptVisibility" class="cashup__wrapper dark-bg m-bottom-1rem">
                        <div class="cashup__table">
                            <div class="cashup__row d-flex align-items-center">
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold h-40 w-100 b-right-bottom px-1rem">{{ `${receiptLabel}` }} Description</div>
                            </div>
                            <div class="cashup__row d-flex align-items-center">
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold h-40 max-70 w-100 b-right-bottom px-1rem"></div>
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold h-40 w-100 b-right-bottom px-1rem">Name/Remarks</div>
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold h-40 max-150 w-100 b-right-bottom px-1rem">Amount</div>
                            </div>

                            <div class="cashup__row d-flex align-items-center">
                                <div class="label d-flex justify-content-center align-items-center font-weight-bold max-70 w-100 b-right-bottom" style="padding: 5px 0px !important;">
                                    <el-button type="peiso-success" @click="createDescription(1)">+</el-button>
                                </div>
                                <div class="w-100 b-right-bottom d-flex align-items-center">
                                    <el-input v-model="receiptDescription" class="peiso-input-default left-align b-right-bottom" placeholder="Input description here..."></el-input>
                                </div>
                                <div class="w-100 max-150 b-bottom d-flex align-items-center px-1rem">
                                    <el-input v-model="receiptAmount" class="peiso-input-default center-align max-150 b-right-bottom"></el-input>
                                </div>
                            </div>

                            <div class="cashup__row d-flex align-items-center" v-for="(item, i) in receipts" :key="`receipts-${i}`">
                                <div class="label d-flex justify-content-center align-items-center font-weight-bold max-70 h-60 w-100 b-right-bottom" style="padding: 5px 0px !important;">
                                    <el-button type="peiso-danger" @click="createDescription(3, i)">-</el-button>
                                </div>
                                <div class="label remarks d-flex justify-content-start align-items-center b-right-bottom h-60 w-100 px-1rem">
                                    <span class="truncate truncate--2">{{ item.description }}</span>
                                </div>
                                <div class="label d-flex justify-content-end align-items-center font-weight-bold max-150 h-60 w-100 b-right-bottom px-1rem">{{ $box.formatMoney5(item.amount) }}</div>
                            </div>


                            <div class="cashup__row d-flex align-items-center">
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold max-70 w-100 h-50 b-right-bottom px-1rem"></div>
                                <div class="label d-flex justify-content-start align-items-center w-100 h-50 b-right-bottom px-1rem">
                                    TOTAL
                                </div>
                                <div class="label d-flex justify-content-end align-items-center font-weight-bold max-150 w-100 h-50 b-right-bottom px-1rem">{{ $box.formatMoney5(calculateTotal(this.receipts)) }}</div>
                            </div>
                            <div class="cashup__row d-flex align-items-center">
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold max-70 w-100 h-50 b-right-bottom px-1rem"></div>
                                <div class="label d-flex justify-content-start align-items-center w-100 h-50 b-right-bottom px-1rem">
                                    TOTAL {{ receiptLabel.toUpperCase() }}
                                </div>
                                <div class="label d-flex justify-content-end align-items-center font-weight-bold max-150 w-100 h-50 b-right-bottom px-1rem">{{ $box.formatMoney5(dailyCashTaking.receipt) }}</div>
                            </div>
                            <div class="cashup__row d-flex align-items-center">
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold max-70 w-100 h-50 b-right-bottom px-1rem"></div>
                                <div class="label d-flex justify-content-start align-items-center w-100 h-50 b-right-bottom px-1rem">
                                    VARIANCE
                                </div>
                                <div class="label d-flex justify-content-end align-items-center font-weight-bold max-150 w-100 h-50 b-right-bottom px-1rem" :class="`${varianceReceiptPromo(1) < 0 ? 'text-red' : ''}`"><span v-if="varianceReceiptPromo(1) > 0">+</span>{{ $box.formatMoney5(varianceReceiptPromo(1)) }}</div>
                            </div>
                        </div>

                    </div>

                    <div v-if="promoVisibility" class="cashup__wrapper dark-bg m-bottom-1rem">
                        <div class="cashup__table">
                            <div class="cashup__row d-flex align-items-center">
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold h-40 w-100 b-right-bottom px-1rem">{{ promoLabel }} Description</div>
                            </div>
                            <div class="cashup__row d-flex align-items-center">
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold h-40 max-70 w-100 b-right-bottom px-1rem"></div>
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold h-40 w-100 b-right-bottom px-1rem">Name/Remarks</div>
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold h-40 max-150 w-100 b-right-bottom px-1rem">Amount</div>
                            </div>

                            <div class="cashup__row d-flex align-items-center">
                                <div class="label d-flex justify-content-center align-items-center font-weight-bold max-70 w-100 b-right-bottom" style="padding: 5px 0px !important;">
                                    <el-button type="peiso-success" @click="createDescription(2)">+</el-button>
                                </div>
                                <div class="w-100 b-right-bottom d-flex align-items-center">
                                    <el-input v-model="promoDescription" class="peiso-input-default left-align b-right-bottom" placeholder="Input description here..."></el-input>
                                </div>
                                <div class="w-100 max-150 b-bottom d-flex align-items-center px-1rem">
                                    <el-input v-model="promoAmount" class="peiso-input-default center-align max-150 b-right-bottom"></el-input>
                                </div>
                            </div>
                            <div class="cashup__row d-flex align-items-center" v-for="(item, i) in promos" :key="`promos-${i}`">
                                <div class="label d-flex justify-content-center align-items-center font-weight-bold max-70 w-100 h-60 b-right-bottom" style="padding: 5px 0px !important;">
                                    <el-button type="peiso-danger" @click="createDescription(4, i)">-</el-button>
                                </div>
                                <div class="label remarks d-flex justify-content-start align-items-center w-100 h-60 b-right-bottom px-1rem">
                                    <span class="truncate truncate--2">{{ item.description }}</span>
                                </div>
                                <div class="label d-flex justify-content-end align-items-center font-weight-bold max-150 w-100 h-60 b-right-bottom px-1rem">{{ $box.formatMoney5(item.amount) }}</div>
                            </div>



                            <div class="cashup__row d-flex align-items-center">
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold max-70 w-100 h-50 b-right-bottom px-1rem"></div>
                                <div class="label d-flex justify-content-start align-items-center w-100 h-50 b-right-bottom px-1rem">
                                    TOTAL
                                </div>
                                <div class="label d-flex justify-content-end align-items-center font-weight-bold max-150 w-100 h-50 b-right-bottom px-1rem">{{ $box.formatMoney5(calculateTotal(this.promos)) }}</div>
                            </div>
                            <div class="cashup__row d-flex align-items-center">
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold max-70 w-100 h-50 b-right-bottom px-1rem"></div>
                                <div class="label d-flex justify-content-start align-items-center w-100 h-50 b-right-bottom px-1rem">
                                    TOTAL {{ promoLabel.toUpperCase() }}
                                </div>
                                <div class="label d-flex justify-content-end align-items-center font-weight-bold max-150 w-100 h-50 b-right-bottom px-1rem">{{ $box.formatMoney5(dailyCashTaking.promo) }}</div>
                            </div>
                            <div class="cashup__row d-flex align-items-center">
                                <div class="label d-flex justify-content-start align-items-center font-weight-bold max-70 w-100 h-50 b-right-bottom px-1rem"></div>
                                <div class="label d-flex justify-content-start align-items-center w-100 h-50 b-right-bottom px-1rem">
                                    VARIANCE
                                </div>
                                <div class="label d-flex justify-content-end align-items-center font-weight-bold max-150 w-100 h-50 b-right-bottom px-1rem" :class="`${varianceReceiptPromo(2) < 0 ? 'text-red' : ''}`"><span v-if="varianceReceiptPromo(2) > 0">+</span>{{ $box.formatMoney5(varianceReceiptPromo(2)) }}</div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </template>

        <template v-else>
            <div class="loading-cashup h-100 d-flex gap-16 align-items-center justify-content-center">
                <i class="el-icon-loading"></i>
                <span>Retrieving cashup data...</span>

            </div>
        </template>

    </div>
</template>

<style lang="scss">
@import 'static/scss/colors';
@import 'static/scss/fonts/fonts';

    .cashup-new-template-container {
        @include montserrat-font(16px, normal, 400, $white) {
            min-height: 800px;
            max-height: calc(100vh - 100px);
            position: relative;
        }

        .cashup_header {
            position: sticky;
            top: -2.2rem;
            z-index: 10;
            background-color: $gray2;
        }

        .el-collapse-item__wrap {
            padding: 0px !important;
        }


        .cashup__wrapper {
            // background-color: $black2;
            // border-radius: 10px;
            // padding: 1rem;
            // border: none;

            .custom-table {
                th {
                    background-color: $black2 !important;
                    border: 1px solid $gray8;
                    color: $white;
                }

                td {
                    background-color: $black2 !important;
                    border: 1px solid $gray8;
                    color: $white;
                }
            }
            .cashup__table {
                > .cashup__header {
                    min-height: 40px;
                    padding: 10px 16px;
                    border: 1px solid $gray8;

                }

                > .cashup__row {
                    border-color: $gray8;
                    border-width: 0px 1px;
                    border-style: solid;

                    > .label {
                        padding: 0px 1rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 5px;
                        padding-bottom: 5px;

                        &.remarks {
                            font-size: 14px !important;

                        }
                    }

                    .el-button--peiso-danger, .el-button--peiso-success {
                        height: 45px;
                        width: 45px;
                    }
                }

            }
        }

        .left {
        }

        .right {

        }

        .peiso-input-default {
            border-color: $gray8;
            border-width: 0px 1px;
            border-style: solid;
            &.h-40 {
                height: 40px;
                .el-input__inner {
                    padding: 0px 1rem !important;
                    height: 100%;
                }
            }



            .el-input__inner {
                @include montserrat-font(16px, normal, 600, $white);
            }

        }
        .peiso-input-default-red {
            .el-input__inner {
               color: $red !important;
            }
        }

        .text-red {
            color: $red !important;
        }

        .text-green {
            color: $green !important
        }


        .max-125 {
            max-width: 125px;
        }

        .max-150 {
            max-width: 150px;
        }

        .max-200 {
            max-width: 200px;
        }


        .max-270 {
            max-width: 270px;
        }

        .max-350 {
            max-width: 350px;
        }

        .max-90 {
            max-width: 90px;
        }

        .max-70 {
            max-width: 70px;
        }

        .h-100px {
            height: 100px;
        }

        .h-50 {
            border-width: 0px 1px;
            border-color: $gray8;
            height: 50px;
        }


        .h-40 {
            border-width: 0px 1px;
            border-color: $gray8;
            height: 40px !important;
        }

        .b-right-bottom {
            border-width: 0px 1px 1px 0px;
            border-style: solid;
            border-color: $gray8;
        }


        .b-bottom {
            border-width: 0px 0px 1px 0px;
            border-style: solid;
            border-color: $gray8;
        }

        .peiso-collapse {
            border: none;
            .el-collapse-item__header, .el-collapse-item__content {
                background-color: $black2;
                color: var(--text-color);
                font-size: 16px !important;
                line-height: normal;
            }

            .el-collapse-item__header {
                padding: 0px 10px;
                border: 1px solid $gray8 !important;
            }

            .el-collapse-item {
                border-radius: 10px;
                background: $black2;
                margin-bottom: 10px;
                padding: 1rem;
            }
        }

        .dark-bg {
            background-color: $black2;
        }

        .light-bg {
            background-color: $gray2 !important;

            .el-input__inner {
                background-color: $gray2 !important;

            }
        }

        .h-60 {
            height: 60px;
        }

        .save-container {
            position: sticky;
            top: -2.5rem;
            z-index: 100;
            margin-left: 1rem;
            background-color: $gray2;
            padding: 1rem 0px !important;
            button {

                font-weight: 400 !important;
            }
        }

        .loading-cashup {
            font-size: 32px;
        }

    }
</style>

<script>
import cashup from '@/api/cashup'
import utils from '@/utils/utils';
import _ from 'lodash'

import Vue from 'vue'
import VueMask from 'v-mask'
Vue.use(VueMask)
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { relativeTimeRounding } from 'moment';
import inputNumber from '@/components/input/inputNumber.vue';
export default {
    data() {
        return {
            manager: '',
            denomination: '',
            total: '',
            rolls: '',
            balance: '',
            tills: [],
            isActiveCashTaking: ['1'],
            dailyCashTaking: {
                name: 'DAILY TOTAL CASH TAKINGS',
                total_cash: 0,
                variance: null,
                receipt: null,
                promo: null,
                eft_pos: null,
                cash: null,
                total: null,
                takings: null,
                total_variance: null,
                safe_counts: [
                    {
                        count_label: '5¢', value: 0.05, rolls: 40, count: '', total: '', balance: '',
                    },
                    {
                        count_label: '10¢', value: 0.1, rolls: 40, count: '', total: '', balance: '',
                    },
                    {
                        count_label: '20¢', value: 0.2, rolls: 20, count: '', total: '', balance: '',
                    },
                    {
                        count_label: '50¢', value: 0.5, rolls: 20, count: '', total: '', balance: '',
                    },
                    {
                        count_label: '$1', value: 1, rolls: 20, count: '', total: '', balance: '',
                    },
                    {
                        count_label: '$2', value: 2, rolls: 25, count: '', total: '', balance: '',
                    },
                    {
                        count_label: '$5', value: 5, count: '', total: '', rolls: '', balance: '',
                    },
                    {
                        count_label: '$10', value: 10, count: '', total: '', rolls: '', balance: '',
                    },
                    {
                        count_label: '$20', value: 20, count: '', total: '', rolls: '', balance: '',
                    },
                    {
                        count_label: '$50', value: 50, count: '', total: '', rolls: '', balance: '',
                    },
                    {
                        count_label: '$100', value: 100, count: '', total: '', rolls: '', balance: '',
                    }
                ],
            },
            consolidatedSafeCounts: {
                name: 'SAFE COUNTS',
                safe_counts: [
                    {
                        count_label: '5¢', value: 0.05, rolls: 40, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '10¢', value: 0.1, rolls: 40, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '20¢', value: 0.2, rolls: 20, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '50¢', value: 0.5, rolls: 20, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '$1', value: 1, rolls: 20, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '$2', value: 2, rolls: 25, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '$5', value: 5, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '$10', value: 10, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '$20', value: 20, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '$50', value: 50, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '$100', value: 100, open_count: '', close_count: '', open_total: null, close_total: null,
                    }
                ],
                open_manager: '',
                open_total_counts: 0,
                open_safe_float: 0,
                close_manager: '',
                close_total_counts: 0,
                close_variance: 0,
                close_safe_float: 0,

            },
            otherDetails: {
                tab_variance: '',
                daily_read: '',
                feedback: '',
            },

            receiptDescription: '',
            receiptAmount: '',
            promoDescription: '',
            promoAmount: '',
            isSend: false,
            receipts: [],
            promos: [],
            isLoading: false,
            isRetreiving: false,
            isTabVarianceShow: true,
            isLoadingSend: false,
            totalReceipt: 0,
            totalPromo: 0,
            currencyMask: createNumberMask({
                                prefix: '$',
                                allowDecimal: true,
                                includeThousandsSeparator: true,
                                allowNegative: true,
                            }),

            showSaving: false,
            isLoading: false,

            promoLabel: "Promo/Account",
            promoVisibility: true,
            safeCountVisibility: true,
            receiptLabel: 'Receipt',
            receiptVisibility: true

        }
    },

    props: {
        reportDate: {
            default: null
        },
        reportDateWithFormat: {
            default: null
        },
        isOpen: {
            default: false
        }
    },

    watch: {
        reportDate(val) {
            if (val != '') {
                this.getTills()
            }
        },

        isOpen(val) {
            if (val) {
                this.getTills()

            }
        }
    },

    methods: {

        getTillsTotalCash() {
            this.tills.map((n) => {
                var sum = 0

                n.safe_counts.forEach(m => {
                    sum += utils.getTotal(m.value, m.count)
                });

                n.receipt = n.receipt ? n.receipt : ''
                n.promo = n.promo ? n.promo : ''
                n.eft_pos = n.eft_pos ? n.eft_pos : ''
                n.takings = n.takings ? n.takings : ''

                var receipt = this.removeCurrencySymbol(n.receipt), promo = this.removeCurrencySymbol(n.promo), eft_pos = this.removeCurrencySymbol(n.eft_pos), takings = this.removeCurrencySymbol(n.takings)
                n.total_cash_amount = sum
                var total = sum - parseFloat(n.default_float)
                n.total_cash = parseFloat(total.toFixed(2))
                n.cash = parseFloat(total.toFixed(2))
                n.total = parseFloat(receipt ? receipt : 0) + parseFloat(promo ? promo : 0) + parseFloat(eft_pos ? eft_pos : 0) +  parseFloat(n.cash ? n.cash : 0)
                n.total = parseFloat(n.total.toFixed(2))
                n.total_variance = parseFloat(n.total ? n.total : 0) - parseFloat(takings ? takings : 0)

            })
            // var total = this.getDailyCashTakingVariance()
            // this.dailyCashTaking.variance = total.sum
            this.getCashTakingTotalCash()

        },

        getCashTakingTotalCash() {

                var sum = 0

                this.dailyCashTaking.safe_counts.forEach(m => {
                    sum += utils.getTotal(m.value, m.count)
                });
                var total = this.getDailyCashTakingVariance()

                this.dailyCashTaking.receipt = total.receipt
                this.dailyCashTaking.promo = total.promo
                this.dailyCashTaking.eft_pos = total.eft_pos
                this.dailyCashTaking.total_cash = sum
                var totalVariance = sum - total.sum.toFixed(2)
                this.dailyCashTaking.variance = totalVariance
                // this.dailyCashTaking.takings = parseFloat(total.takings)
                this.dailyCashTaking.total = parseFloat(this.dailyCashTaking.receipt ? this.dailyCashTaking.receipt : 0) + parseFloat(this.dailyCashTaking.promo ? this.dailyCashTaking.promo : 0) + parseFloat(this.dailyCashTaking.eft_pos ? this.dailyCashTaking.eft_pos : 0) +  parseFloat(this.dailyCashTaking.total_cash ? this.dailyCashTaking.total_cash : 0) +  parseFloat(this.dailyCashTaking.cash ? this.dailyCashTaking.cash : 0)

                this.dailyCashTaking.total_variance = parseFloat(this.dailyCashTaking.total ? this.dailyCashTaking.total : 0) - parseFloat(this.dailyCashTaking.takings ? this.removeCurrencySymbol(this.dailyCashTaking.takings) : 0)

        },

        getSafeCountsTotal() {

            var openSum = 0, closeSum = 0

            this.consolidatedSafeCounts.safe_counts.map((n) => {
                n.open_total = utils.getTotal(n.value, n.open_count)
                n.close_total = utils.getTotal(n.value, n.close_count)
            })

            this.consolidatedSafeCounts.safe_counts.forEach(n => {
                openSum += utils.getTotal(n.value, n.open_count)
                closeSum += utils.getTotal(n.value, n.close_count)
            });

            this.consolidatedSafeCounts.open_total_counts = openSum
            this.consolidatedSafeCounts.close_total_counts = closeSum

            this.consolidatedSafeCounts.open_variance = openSum - parseFloat(this.consolidatedSafeCounts.open_safe_float)
            this.consolidatedSafeCounts.close_variance = closeSum - parseFloat(this.consolidatedSafeCounts.open_safe_float)
        },

        createDescription(type, idx = 0) {
            // create new receipts
            if (type == 1) {
                if (this.receiptDescription == '' ||this.receiptAmount == '') {
                    utils.alert2('', 'Please input receipt description and amount.', 'error')
                    return
                }
                this.receipts.push({
                    description: this.receiptDescription,
                    amount: parseFloat(this.removeCurrencySymbol(this.receiptAmount))
                })

                this.receiptDescription = ''
                this.receiptAmount = ''
            } else if (type ==2) {
                if (this.promoDescription == '' || this.promoAmount == '') {
                    utils.alert2('', 'Please input promos description and amount.', 'error')
                    return
                }
                this.promos.push({
                    description: this.promoDescription,
                    amount: parseFloat(this.removeCurrencySymbol(this.promoAmount))
                })

                this.promoDescription = ''
                this.promoAmount = ''
            // delete receipts
            } else if (type == 3) {
                this.receipts.splice(idx, 1)
            } else if (type == 4) {
                this.promos.splice(idx, 1)
            }
            this.totalReceipt = this.calculateTotal(this.receipts)
            this.totalPromo = this.calculateTotal(this.promos)
            this.getCashTakingTotalCash()
            this.saveCashupOnly()
        },

        calculateTotal(array) {
            var sum = 0
            array.forEach(n => {
                sum += n.amount
            });

            return sum
        },

        getDailyCashTakingVariance() {
            var sum = 0, receipt = 0, promo = 0, eft_pos = 0, takings = 0
            this.tills.forEach(n => {
                var contakings = this.removeCurrencySymbol(n.takings),
                conreceipt = this.removeCurrencySymbol(n.receipt),
                conpromo = this.removeCurrencySymbol(n.promo),
                coneft_pos = this.removeCurrencySymbol(n.eft_pos)

                // sum += n.total_cash <= 0 ? 0 : n.total_cash
                sum += n.total_cash

                receipt += parseFloat(conreceipt) ? parseFloat(conreceipt) : 0
                promo += parseFloat(conpromo) ? parseFloat(conpromo) : 0
                eft_pos += parseFloat(coneft_pos) ? parseFloat(coneft_pos) : 0
                takings += parseFloat(contakings) ? parseFloat(contakings) : 0
            });

            return {
                sum: sum,
                receipt: receipt,
                promo: promo,
                eft_pos: eft_pos,
                takings: takings
            }
        },

        getBalanced() {
          this.tills.map((item, i) => {
                var totalCash = item.total_cash;

                var items = item.safe_counts.sort((a, b) => b.value - a.value);
                items.map(res => res.balance = '');

                if (item.total_cash < 0) {
                    // Handle cases where total_cash is negative, if applicable.
                } else {
                    let iterationLimit = 1000; // Safeguard to prevent infinite loop
                    let iterationCount = 0;

                    while (totalCash > 0 && iterationCount < iterationLimit) {
                        iterationCount++;

                        items.map((res) => {
                            var cnt = parseInt(res.count) ? parseInt(res.count) : 0;
                            var balance = parseInt(res.balance) ? parseInt(res.balance) : 0;

                            if (cnt && cnt > balance) {
                                var total = res.value * 1;
                                var remaining = parseFloat(totalCash) - total;

                                if (remaining >= 0) {
                                    balance += 1;
                                    totalCash = remaining.toFixed(2);
                                    res.balance = balance;
                                } else if (total < 0.5) {
                                    totalCash = 0;
                                    res.balance = '';
                                }
                            }

                            res.balance = res.balance ? res.balance : '';
                            return res;
                        });
                    }

                    // Check if iteration limit was reached (optional logging or handling)
                    if (iterationCount >= iterationLimit) {
                        console.warn('Iteration limit reached to prevent infinite loop.');
                    }
                }

                item.safe_counts = items.sort((a, b) => a.value - b.value);
            });


            // this.tills.map((n) => {

            //     if (parseFloat(n.total_cash) > 0) {
            //         var total_cash = parseFloat(n.total_cash)
            //         for (var i = n.safe_counts.length - 1; i >= 0; i--) {
            //             var count = parseFloat(n.safe_counts[i].count)
            //             if (count) {
            //                 var balance = 0
            //                 while (total_cash >= n.safe_counts[i].value && balance < count) {
            //                     balance++
            //                     n.safe_counts[i].balance = balance
            //                     total_cash -= n.safe_counts[i].value
            //                 }
            //             }
            //         }
            //     }
            // })

            this.saveCashupOnly()
        },

        getCashUpRecord() {
            cashup.getCashUpRecord({reportDate: this.reportDate}).then((res) => {
                console.log(res)
            })
        },

        async getTills() {
            this.isRetreiving = true
            var cashupData = await cashup.displaySettings()
            if (cashupData.data.code != 0) {
                utils.alert2('', `Error opening cashup. ${cashupData.data.message}.   `, 'error')
                this.$emit('open-cashup-setting')
                return
            }
            var defaultTills = cashupData.data.data.tills.map((n) => {
                var data = {
                    isFocused: false,
                    name: n.name,
                    default_float : n.tillFloat,
                    receipt : null,
                    promo : null,
                    eft_pos : null,
                    cash : null,
                    total : null,
                    takings : null,
                    variance : null,
                    total_variance : null,
                    safe_counts : [
                        {
                            count_label: '5¢', value: 0.05, rolls: 0, count: '', total: '', rolls: '', balance: '',
                        },
                        {
                            count_label: '10¢', value: 0.1, rolls: 0, count: '', total: '', rolls: '', balance: '',
                        },
                        {
                            count_label: '20¢', value: 0.2, rolls: 0, count: '', total: '', rolls: '', balance: '',
                        },
                        {
                            count_label: '50¢', value: 0.5, rolls: 0, count: '', total: '', rolls: '', balance: '',
                        },
                        {
                            count_label: '$1', value: 1, rolls: 0, count: '', total: '', rolls: '', balance: '',
                        },
                        {
                            count_label: '$2', value: 2, rolls: 0, count: '', total: '', rolls: '', balance: '',
                        },
                        {
                            count_label: '$5', value: 5, count: '', total: '', rolls: '', balance: '',
                        },
                        {
                            count_label: '$10', value: 10, count: '', total: '', rolls: '', balance: '',
                        },
                        {
                            count_label: '$20', value: 20, count: '', total: '', rolls: '', balance: '',
                        },
                        {
                            count_label: '$50', value: 50, count: '', total: '', rolls: '', balance: '',
                        },
                        {
                            count_label: '$100', value: 100, count: '', total: '', rolls: '', balance: '',
                        }
                    ]
                }

                return data
            })


            this.consolidatedSafeCounts.open_safe_float = cashupData.data.data.safeFloat.open
            this.consolidatedSafeCounts.close_safe_float = cashupData.data.data.safeFloat.open

            this.isTabVarianceShow = cashupData.data.data.tabVariance

            this.promoLabel = cashupData.data.data.promoLabel ? cashupData.data.data.promoLabel : "Promo/Account"
            this.promoVisibility = cashupData.data.data.promoVisibility
            this.safeCountVisibility = cashupData.data.data.safeCountVisibility
            this.receiptLabel = cashupData.data.data.receiptLabel ? cashupData.data.data.receiptLabel : 'Receipts'
            this.receiptVisibility = cashupData.data.data.receiptVisibility
       
            try {
                this.manager = '';

                var retrieveCashup = await cashup.getCashUpRecord({reportDate: this.reportDate})
         
                if (retrieveCashup && retrieveCashup.data.code == 0 && retrieveCashup.data.data.daily_takings) {
                    const isPinNeeded = parseInt(sessionStorage.getItem('isPinNeeded'))
                    if (retrieveCashup.data.data.is_sent && isPinNeeded) {
                        this.$emit('open-pin')
                    }
                    this.manager = retrieveCashup.data.data.manager

                    var tillsData = retrieveCashup.data.data.tills.map((n) => {
                        var till = cashupData.data.data.tills.find((till) => till.name == n.name)
                        var data = {}
                        if (till) {
                            data = {
                                // name: n.name,
                                // default_float : n.default_float,
                                isFocused: false,
                                receipt : n.receipt && this.receiptVisibility ? utils.formatMoney5(n.receipt) : 0,
                                promo : n.promo && this.promoVisibility ? utils.formatMoney5(n.promo) : 0,
                                eft_pos : n.eft_pos ? utils.formatMoney5(n.eft_pos) : 0,
                                cash : n.cash ? n.cash : 0,
                                total : n.total ? n.total : 0,
                                takings : n.takings ? utils.formatMoney5(n.takings) : 0,
                                variance : n.variance ? n.variance : 0,
                                total_variance : n.total_variance ? n.total_variance : 0,
                                safe_counts : [
                                    {
                                        count_label: '5¢', value: 0.05, rolls: 0, count: '', total: '', rolls: '', balance: '',
                                    },
                                    {
                                        count_label: '10¢', value: 0.1, rolls: 0, count: '', total: '', rolls: '', balance: '',
                                    },
                                    {
                                        count_label: '20¢', value: 0.2, rolls: 0, count: '', total: '', rolls: '', balance: '',
                                    },
                                    {
                                        count_label: '50¢', value: 0.5, rolls: 0, count: '', total: '', rolls: '', balance: '',
                                    },
                                    {
                                        count_label: '$1', value: 1, rolls: 0, count: '', total: '', rolls: '', balance: '',
                                    },
                                    {
                                        count_label: '$2', value: 2, rolls: 0, count: '', total: '', rolls: '', balance: '',
                                    },
                                    {
                                        count_label: '$5', value: 5, count: '', total: '', rolls: '', balance: '',
                                    },
                                    {
                                        count_label: '$10', value: 10, count: '', total: '', rolls: '', balance: '',
                                    },
                                    {
                                        count_label: '$20', value: 20, count: '', total: '', rolls: '', balance: '',
                                    },
                                    {
                                        count_label: '$50', value: 50, count: '', total: '', rolls: '', balance: '',
                                    },
                                    {
                                        count_label: '$100', value: 100, count: '', total: '', rolls: '', balance: '',
                                    }
                                ]
                            }

                            data.name = till.name
                            data.default_float = till.tillFloat
                            data.safe_counts = n.safe_counts.map((n) => {
                                var data = {
                                    count_label: n.count_label,
                                    value: n.value ? n.value : null,
                                    rolls: 0,
                                    count: n.count ? n.count : null,
                                    total: n.total ? n.total : null,
                                    balance: n.balance ? n.balance : null
                                }

                                return data
                            })
                        } else {
                            data = n
                        }


                        return data
                    })

                    this.tills = defaultTills.map((n) => {
                        var data = tillsData.find((m) => n.name == m.name)
                        if (data) {
                            return data
                        } else {
                            return n
                        }
                    })

                    var safe_counts = retrieveCashup.data.data.safe_counts,

                    daily_takings = retrieveCashup.data.data.daily_takings


                    var data = {
                            name: 'SAFE COUNTS',
                            open_total_counts: safe_counts.open_total_counts ? safe_counts.open_total_counts : null,
                            // open_safe_float: safe_counts.open_safe_float ? safe_counts.open_safe_float : null,
                            open_variance: safe_counts.open_variance ? safe_counts.open_variance : null,
                            // close_safe_float: safe_counts.close_safe_float ? safe_counts.close_safe_float : null,
                            close_total_counts: safe_counts.close_total_counts ? safe_counts.close_total_counts : null,
                            close_variance: safe_counts.close_variance ? safe_counts.close_variance : null,
                        }
                        data.safe_counts = safe_counts.safe_counts.map((n) => {
                            var data = {
                                count_label: n.count_label,
                                value: n.value ? n.value : null,
                                rolls: 0,
                                open_count: n.open_count,
                                close_count: n.close_count,
                                open_total: n.open_total,
                                close_total: n.close_total,
                            }

                            return data
                        })

                    var daily_takings_data = {
                        name: 'DAILY TOTAL CASH TAKINGS',
                        total_cash: daily_takings.total_cash ? daily_takings.total_cash : null,
                        variance: daily_takings.variance ? daily_takings.variance : null,
                        receipt: daily_takings.receipt ? daily_takings.receipt : null,
                        promo: daily_takings.promo ? daily_takings.promo : null,
                        eft_pos: daily_takings.eft_pos ? daily_takings.eft_pos : null,
                        cash: daily_takings.cash ? daily_takings.cash : null,
                        total: daily_takings.total ? daily_takings.total : null,
                        takings: daily_takings.takings ? daily_takings.takings : 0,
                        total_variance: daily_takings.total_variance ? daily_takings.total_variance : null,
                    }
                    daily_takings_data.safe_counts = daily_takings.safe_counts.map((n) => {
                        var data = {
                            count_label: n.count_label,
                            value: n.value ? n.value : null,
                            rolls: 0,
                            count: n.count ? n.count : null,
                            total: n.total ? n.total : null,
                            balance: n.balance ? n.balance : null
                        }

                        return data
                    })


                    var other_details = {
                        tab_variance: retrieveCashup.data.data.tab_variance ? retrieveCashup.data.data.tab_variance : null,
                        daily_read: retrieveCashup.data.data.daily_read ? retrieveCashup.data.data.daily_read : null,
                        feedback: retrieveCashup.data.data.feedback ? retrieveCashup.data.data.feedback : null,
                    }

                    this.otherDetails = other_details


                    this.consolidatedSafeCounts = safe_counts



                    if (!safe_counts.open_safe_float || !safe_counts.close_safe_float) {
                    this.consolidatedSafeCounts.open_safe_float = cashupData.data.data.safeFloat.open
                    this.consolidatedSafeCounts.close_safe_float = cashupData.data.data.safeFloat.open
                    }


                    this.dailyCashTaking = daily_takings_data
                    this.receipts = retrieveCashup.data.data.receipts ? retrieveCashup.data.data.receipts : null
                    this.promos = retrieveCashup.data.data.promos ? retrieveCashup.data.data.promos : null

                    this.totalReceipt = this.calculateTotal(this.receipts)
                    this.totalPromo = this.calculateTotal(this.promos)

                } else {

                    if (retrieveCashup.data.code == 0 && (retrieveCashup.data.data.tills && retrieveCashup.data.data.tills.length > 0)) {
                        let eft_pos = 0;
                        let takings = 0;

                        this.tills = retrieveCashup.data.data.tills.map((n) => {
                            let till = defaultTills.find((till) => till.name == n.name)
                            let data = {};

                            eft_pos += n.eft_pos;
                            takings += n.takings

                            if (till) {
                                data = {
                                    ...till,
                                    name: n.name,
                                    takings: n.takings,
                                    eft_pos: n.eft_pos,
                                }
                            } else {
                                data = {
                                    isFocused: false,
                                    name: n.name,
                                    default_float: n.default_float,
                                    receipt : null,
                                    promo: null,
                                    eft_pos: n.eft_pos,
                                    cash: null,
                                    total: null,
                                    takings: n.takings,
                                    variance: null,
                                    total_variance: null,
                                    safe_counts: [
                                        {
                                            count_label: '5¢', value: 0.05, rolls: 0, count: '', total: '', rolls: '', balance: '',
                                        },
                                        {
                                            count_label: '10¢', value: 0.1, rolls: 0, count: '', total: '', rolls: '', balance: '',
                                        },
                                        {
                                            count_label: '20¢', value: 0.2, rolls: 0, count: '', total: '', rolls: '', balance: '',
                                        },
                                        {
                                            count_label: '50¢', value: 0.5, rolls: 0, count: '', total: '', rolls: '', balance: '',
                                        },
                                        {
                                            count_label: '$1', value: 1, rolls: 0, count: '', total: '', rolls: '', balance: '',
                                        },
                                        {
                                            count_label: '$2', value: 2, rolls: 0, count: '', total: '', rolls: '', balance: '',
                                        },
                                        {
                                            count_label: '$5', value: 5, count: '', total: '', rolls: '', balance: '',
                                        },
                                        {
                                            count_label: '$10', value: 10, count: '', total: '', rolls: '', balance: '',
                                        },
                                        {
                                            count_label: '$20', value: 20, count: '', total: '', rolls: '', balance: '',
                                        },
                                        {
                                            count_label: '$50', value: 50, count: '', total: '', rolls: '', balance: '',
                                        },
                                        {
                                            count_label: '$100', value: 100, count: '', total: '', rolls: '', balance: '',
                                        }
                                    ]
                                }
                            }

                            return data;

                        })

                        this.clearingFields(cashupData)

                        this.dailyCashTaking = {
                            ...this.dailyCashTaking,
                            takings,
                            eft_pos
                        }
                    
                    } else {
                        this.tills = defaultTills

                        this.clearingFields(cashupData)
                    
                    }
                }
            } catch (error) {
                this.tills = defaultTills
                this.isRetreiving = false
                this.clearingFields(cashupData)
            }


            this.isRetreiving = false
            this.getTillsTotalCash()
            this.getCashTakingTotalCash()
            this.getSafeCountsTotal()
        },

        saveCashupRecord(isSend=false) {
            if (isSend) {
                this.isLoadingSend = true;
            } else {
                this.isLoading = true
            }
            var dailyTakings = parseFloat(this.removeCurrencySymbol(this.dailyCashTaking.takingsInput))

            var payloads = {
                manager: this.manager,
                report_date: this.reportDate,
                safe_counts: this.consolidatedSafeCounts,
                receipts: this.receipts,
                promos: this.promos,
                daily_takings: this.dailyCashTaking,
                tab_variance: parseFloat(this.removeCurrencySymbol(this.otherDetails.tab_variance)),
                daily_read: parseFloat(this.removeCurrencySymbol(this.otherDetails.daily_read)),
                feedback: this.otherDetails.feedback
            }

            payloads.tills = this.tills.map((n) => {

                var data = {}
                data.cash = n.cash
                data.default_float = n.default_float
                data.eft_pos = parseFloat(this.removeCurrencySymbol(n.eft_pos))
                data.isFocused = n.isFocused
                data.name = n.name
                data.promo = parseFloat(this.removeCurrencySymbol(n.promo))
                data.receipt = parseFloat(this.removeCurrencySymbol(n.receipt))
                data.safe_counts = n.safe_counts
                data.takings = parseFloat(this.removeCurrencySymbol(n.takings))
                data.total = n.total
                data.total_cash = n.total_cash
                data.total_cash_amount = n.total_cash_amount
                data.total_variance = n.total_variance
                data.variance = n.variance

                return data
            })

            cashup.saveCashupRecord(payloads, isSend).then((res) => {
                this.isLoading = false
                this.isLoadingSend = false;

                if (!isSend) {
                    this.isLoading = false
                    setTimeout(() => {
                        this.showSaving = false
                    }, 1000);
                } else {
                    if (res.data.code == 0) {
                        utils.alert2('', 'Cashup record successfully saved', 'success')
                    } else {
                        utils.alert2('', res.data.message, 'error')
                    }
                }
            })
        },

        varianceReceiptPromo(type) {
            if (type == 1) {
                return parseFloat(this.totalReceipt) - parseFloat(this.dailyCashTaking.receipt)
            } else if (type == 2) {
                return parseFloat(this.totalPromo) - parseFloat(this.dailyCashTaking.promo)
            }
        },

        removeCurrencySymbol(amount) {
            var currency = amount ? amount.toString() : ''

            if (currency != '') {
                currency =  currency.replace('\$', '').replace(',', '')
            }


            return currency

        },

        distributeAmount(denominations, counts, amount) {
            // let initialDistribution = counts.map(count => Math.floor(count * 0.5)); // 50% of initial counts
            // let initialTotal = 0;

            // // Calculate the initial total amount
            // initialDistribution.forEach((count, index) => {
            //     initialTotal += count * denominations[index];
            // });

            // let remainingAmount = amount - initialTotal;

            // // Distribute the remaining amount
            // for (let i = denominations.length - 1; i >= 0; i--) {
            //     if (remainingAmount >= denominations[i]) {
            //         let additionalCount = Math.floor(remainingAmount / denominations[i]);
            //         initialDistribution[i] += additionalCount;
            //         remainingAmount -= additionalCount * denominations[i];
            //     }
            // }

            // return initialDistribution;

            let initialDistribution = counts.map(count => Math.floor(count * 0.5)); // 50% of initial counts
            let initialTotal = 0;

            // Calculate the initial total amount
            initialDistribution.forEach((count, index) => {
                initialTotal += count * denominations[index];
            });

            let remainingAmount = amount - initialTotal;

            // Distribute the remaining amount as evenly as possible
            for (let i = denominations.length - 1; i >= 0; i--) {
                while (remainingAmount >= denominations[i] && initialDistribution[i] < counts[i]) {
                    initialDistribution[i]++;
                    remainingAmount -= denominations[i];
                }
            }

            return initialDistribution;


        },

        saveCashupOnly: _.debounce(function(e) {
            this.showSaving = true
            this.isLoading = true
            this.saveCashupRecord()
        }, 1000),

        keyupProcess(refTo, isArray = 0) {
            this.$nextTick(() => {
                if (isArray) {
                    var refInput = this.$refs[refTo][0].$el.getElementsByTagName('input')[0]
                    if (refInput) {
                        refInput.focus()
                        setTimeout(() => {
                            refInput.select()
                        }, 1);
                    }
                } else {
                    if (refTo == 'feedback1') {
                        this.$refs[refTo].$el.getElementsByTagName('textarea')[0].select()
                        this.$refs[refTo].$el.getElementsByTagName('textarea')[0].focus()
                    } else {
                        this.$refs[refTo].$el.getElementsByTagName('input')[0].select()
                        this.$refs[refTo].$el.getElementsByTagName('input')[0].focus()
                    }
                }
            });

        },

        clearingFields(cashupData) {
            this.dailyCashTaking = {
                name: 'DAILY TOTAL CASH TAKINGS',
                total_cash: 0,
                variance: null,
                receipt: null,
                promo: null,
                eft_pos: null,
                cash: null,
                total: null,
                takings: null,
                total_variance: null,
                safe_counts: [
                    {
                        count_label: '5¢', value: 0.05, rolls: 40, count: '', total: '', balance: '',
                    },
                    {
                        count_label: '10¢', value: 0.1, rolls: 40, count: '', total: '', balance: '',
                    },
                    {
                        count_label: '20¢', value: 0.2, rolls: 20, count: '', total: '', balance: '',
                    },
                    {
                        count_label: '50¢', value: 0.5, rolls: 20, count: '', total: '', balance: '',
                    },
                    {
                        count_label: '$1', value: 1, rolls: 20, count: '', total: '', balance: '',
                    },
                    {
                        count_label: '$2', value: 2, rolls: 25, count: '', total: '', balance: '',
                    },
                    {
                        count_label: '$5', value: 5, count: '', total: '', rolls: '', balance: '',
                    },
                    {
                        count_label: '$10', value: 10, count: '', total: '', rolls: '', balance: '',
                    },
                    {
                        count_label: '$20', value: 20, count: '', total: '', rolls: '', balance: '',
                    },
                    {
                        count_label: '$50', value: 50, count: '', total: '', rolls: '', balance: '',
                    },
                    {
                        count_label: '$100', value: 100, count: '', total: '', rolls: '', balance: '',
                    }
                ],
            }

            this.otherDetails = {
                tab_variance: '',
                daily_read: '',
                feedback: '',
            }

            this.consolidatedSafeCounts = {
                name: 'SAFE COUNTS',
                safe_counts: [
                    {
                        count_label: '5¢', value: 0.05, rolls: 40, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '10¢', value: 0.1, rolls: 40, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '20¢', value: 0.2, rolls: 20, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '50¢', value: 0.5, rolls: 20, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '$1', value: 1, rolls: 20, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '$2', value: 2, rolls: 25, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '$5', value: 5, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '$10', value: 10, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '$20', value: 20, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '$50', value: 50, open_count: '', close_count: '', open_total: null, close_total: null,
                    },
                    {
                        count_label: '$100', value: 100, open_count: '', close_count: '', open_total: null, close_total: null,
                    }
                ],
                open_manager: '',
                open_total_counts: 0,
                open_safe_float: cashupData.data.data ? cashupData.data.data.safeFloat.open : 0,
                close_manager: '',
                close_total_counts: 0,
                close_variance: 0,
                close_safe_float: cashupData.data.data ? cashupData.data.data.safeFloat.open : 0,

            }

            this.receipts = []
            this.promos = []
        }

    },
    mounted() {
        this.getTills()
    },

    components: {
        inputNumber: inputNumber
    }
}
</script>



// WEBPACK FOOTER //
// src/components/modal/cashUpBankingV2.vue